import {
  StudentTeacherMappingType,
  TeacherPosition,
  TeacherStatus,
} from '@asset/enum/UserEnum';
import { authAPI } from '../../core/instance';
import qs from 'qs';
import { CommonResponse } from '@apis/common/response';
import { TeacherInformationV2 } from '@asset/type/userType';
import { StudyContentPageType } from '@asset/enum/materialEnum';
import { PageBasedPagination } from '@asset/type/common/response';

export const getPredictElapsedTimeSecondApi = async (reqBody: {
  studyContentId?: number;
  contentType?: StudyContentPageType | 'my-study-contents';
  checkedPageRange?: number[];
  // pageIds를 보내는 경우 studyContentId, contentType를 보내지 않아도 됨
  pageIds?: number[];
}): Promise<
  {
    totalProblemCountV2: number;
    totalProblemCount: number;
    predictElapsedTime: number;
  } & CommonResponse
> => {
  const data = await authAPI
    .post(`/api/teachers/predict/elapsed-time/`, reqBody)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const getTeachersApi = async (parameters: {
  branchCategories?: string[];
  branchIds?: number[];
  ids?: number[];
  page?: number;
  pageSize?: number;
  positions?: TeacherPosition[];
  search?: string;
  statuses?: TeacherStatus[];
}): Promise<
  CommonResponse & {
    data: {
      pagination: PageBasedPagination;
      results: TeacherInformationV2[];
    };
  }
> => {
  let url = '/api/v2/teachers';
  const convertedParameters = qs.stringify(parameters, {
    arrayFormat: 'comma',
    skipNulls: true,
  });
  if (convertedParameters !== '') {
    url += `?${convertedParameters}`;
  }
  const data = await authAPI
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const getTeacherApi = async (
  teacherId: number,
): Promise<
  CommonResponse & {
    data: TeacherInformationV2;
  }
> => {
  const data = await authAPI
    .get(`/api/v2/teachers/${teacherId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const createTeacherApi = async (reqBody: {
  name: string;
  branchId: number;
  position: TeacherPosition;
  phoneNumber: string;
  status: TeacherStatus;
  students: {
    id: number;
    teacherMappingType: StudentTeacherMappingType;
  }[];
}): Promise<CommonResponse & { data: TeacherInformationV2 }> => {
  const data = await authAPI
    .post('/api/v2/teachers', reqBody)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};

export const patchTeacherApi = async (
  teacherId: number,
  reqBody: {
    name: string;
    branchId: number;
    position: TeacherPosition;
    phoneNumber: string;
    status: TeacherStatus;
    students: {
      id: number;
      teacherMappingType: StudentTeacherMappingType;
    }[];
  },
): Promise<CommonResponse & { data: TeacherInformationV2 }> => {
  const data = await authAPI
    .patch(`/api/v2/teachers/${teacherId}`, reqBody)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return data;
};
